import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { filter, length, maxBy, map, ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Sendungen_FlexitarifAuswahl, Sendungen_SendungsOptionData, Sendungen_SendungsOption, Sendungen_FlexitarifResult_$reflection, Sendungen_FlexitarifAuswahl_$reflection, Sendungen_FlexitarifFuerSendung_$reflection, Sendungen_SendungsOptionData_$reflection, Sendungen_Sendung_$reflection, Sendungen_Filiale_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { class_type, array_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { comparePrimitives, defaultOf, equals, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { UploadResult_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { GlobalMessageBox_WarningWithTitle, GlobalMessageBox_ErrorWithTitle, GlobalMessageBox_SuccessWithTitle, GlobalMessageBox_Error_Z721C83C5, Remote$1, GlobalMsg, GlobalMessageBox, GlobalMessageBoxButton, GlobalMessageBoxButtonType, GlobalMessageType } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { value as value_2, map as map_1, defaultArg, some } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { Model, Model_get_Init, Msg } from "./Types.fs.js";
import { containsKey } from "../../../fable_modules/fable-library-js.4.19.0/Map.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { errorCmd, request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { tryFind } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { last, item, equalsWith } from "../../../fable_modules/fable-library-js.4.19.0/Array.js";
import { webPrint } from "../../../../Bfs.Web.Portale/Preview.fs.js";
import { asMoney } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";

export function Http_getFilialen() {
    const response = fetch("/api/sendungen/filialen", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(array_type(Sendungen_Filiale_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getSendungen(filialeId) {
    const response = fetch(`/api/sendungen/filialen/${filialeId}`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(array_type(Sendungen_Sendung_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postSendungDateiUpload(sendungsId, file) {
    const formData = new FormData();
    formData.append("file", file);
    const response = fetch(`/api/sendungen/${sendungsId}/dateien/`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [((Item) => (new Types_HttpRequestHeaders(11, [Item])))("multipart/form-data")]), new Types_RequestProperties(2, [formData])])), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(UploadResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_deleteSendungDateiUpload(sendungId, fileId) {
    const response = fetch(`/api/sendungen/${sendungId}/dateien/${fileId}`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), singleton(new Types_RequestProperties(0, ["DELETE"]))), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(class_type("System.Guid"), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getVereinbarung(prepareAgreementData) {
    const response = sendJson("/api/sendungen/option", toString(0, Auto_generateBoxedEncoder_437914C6(Sendungen_SendungsOptionData_$reflection(), undefined, undefined, undefined)(prepareAgreementData)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            return response_1_1.text();
        }
    });
}

export function Http_postAuftragErteilen(prepareAgreementData) {
    return sendJson("/api/sendungen/auftrag", toString(0, Auto_generateBoxedEncoder_437914C6(Sendungen_SendungsOptionData_$reflection(), undefined, undefined, undefined)(prepareAgreementData)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_getFlexitarif(sendungId) {
    const response = fetch(`/api/sendungen/${sendungId}/flexitarif`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Sendungen_FlexitarifFuerSendung_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postFlexitarif(sendungId, flexitarifAuswahl) {
    const response = sendJson(`/api/sendungen/${sendungId}/flexitarif`, toString(0, Auto_generateBoxedEncoder_437914C6(Sendungen_FlexitarifAuswahl_$reflection(), undefined, undefined, undefined)(flexitarifAuswahl)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Sendungen_FlexitarifResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

const State_SESSION_DATA_KEY_INFO_BOX_HIDDEN = "SendungenInfoBoxHidden";

function State_getSendungsOptionData(model) {
    const matchValue = model.SelectedSendung;
    const matchValue_1 = model.SelectedSendungsOption;
    let matchResult, sendung, sendung_1, sendung_2, sendung_3;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            switch (matchValue_1.tag) {
                case 1: {
                    matchResult = 1;
                    sendung_1 = matchValue;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    sendung_2 = matchValue;
                    break;
                }
                case 3: {
                    matchResult = 3;
                    sendung_3 = matchValue;
                    break;
                }
                default: {
                    matchResult = 0;
                    sendung = matchValue;
                }
            }
        }
        else {
            matchResult = 4;
        }
    }
    else {
        matchResult = 4;
    }
    switch (matchResult) {
        case 0:
            return new Sendungen_SendungsOptionData(sendung.SendungId, new Sendungen_SendungsOption(0, []), map((u) => u.Id, model.CurrentUploadList));
        case 1:
            return new Sendungen_SendungsOptionData(sendung_1.SendungId, new Sendungen_SendungsOption(1, []), map((u_1) => u_1.Id, model.CurrentUploadList));
        case 2:
            return new Sendungen_SendungsOptionData(sendung_2.SendungId, new Sendungen_SendungsOption(2, []), empty());
        case 3:
            return new Sendungen_SendungsOptionData(sendung_3.SendungId, new Sendungen_SendungsOption(3, []), empty());
        default:
            throw new Error("bad model state");
    }
}

function State_createPrintLegalCmd(title, content, okCaption, okMsg) {
    const msg = new Msg(31, [new GlobalMsg(3, [new GlobalMessageBox(new GlobalMessageType(1, []), title, content, ofArray([new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(3, []), okCaption, some(okMsg), true), new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(0, []), "Drucken", some(new Msg(18, [title, content])), false), new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(2, []), "Abbrechen", undefined, true)]))])]);
    return singleton((dispatch) => {
        dispatch(msg);
    });
}

function State_createInfoBoxCommand(sendung, message, cancelMsg) {
    const msg = new Msg(31, [new GlobalMsg(3, [new GlobalMessageBox(new GlobalMessageType(1, []), `Sendung ${sendung.SendungsNr}`, message, ofArray([new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(3, []), "Bestätigen", some(new Msg(19, [])), true), new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(2, []), "Abbrechen", some(cancelMsg), true)]))])]);
    return singleton((dispatch) => {
        dispatch(msg);
    });
}

export function State_init(page, user, lastModel) {
    const infoBoxHidden = defaultArg(map_1((u) => containsKey(State_SESSION_DATA_KEY_INFO_BOX_HIDDEN, u.SessionData), user), false);
    let model;
    const bind$0040 = Model_get_Init();
    model = (new Model(bind$0040.Filialen, bind$0040.SelectedFilialeId, !infoBoxHidden, bind$0040.Sendungen, bind$0040.SelectedSendung, bind$0040.SelectedSendungsOption, bind$0040.CurrentUploadCount, bind$0040.Sending, bind$0040.CurrentUploadList, bind$0040.Flexitarif, bind$0040.FlexitarifAuswahl, bind$0040.AgbAkzeptiert));
    if (page.fields[0] != null) {
        const filialeId = page.fields[0];
        return [new Model(model.Filialen, filialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_batch(ofArray([singleton((dispatch_1) => {
            dispatch_1(new Msg(0, []));
        }), singleton((dispatch_2) => {
            dispatch_2(new Msg(2, [filialeId]));
        })]))];
    }
    else {
        return [model, singleton((dispatch) => {
            dispatch(new Msg(0, []));
        })];
    }
}

export function State_update(msg, model) {
    let testExpr, testExpr_1, msg_3, msg_4, matchValue_1, msg_6, msg_8, msg_10, message_12, bind$0040, msg_12, msg_14;
    let matchResult, filialen, ex, filialeId_1, sendungen, ex_1, filialeId_3, sendung, files, sendungsId, body, exn, file_1, id, exn_2, sendungsOption, sendung_1, sendung_2, s, exn_4, content, title, exn_6, sendung_3, r, exn_8, tag, agb, r_1, exn_10;
    switch (msg.tag) {
        case 6: {
            matchResult = 8;
            break;
        }
        case 15:
        case 13: {
            matchResult = 18;
            break;
        }
        case 16: {
            matchResult = 19;
            break;
        }
        case 19: {
            matchResult = 23;
            break;
        }
        case 23: {
            matchResult = 29;
            break;
        }
        case 25: {
            matchResult = 31;
            break;
        }
        case 26: {
            matchResult = 32;
            break;
        }
        case 28: {
            matchResult = 34;
            break;
        }
        case 30: {
            matchResult = 37;
            break;
        }
        case 31: {
            matchResult = 38;
            break;
        }
        case 1: {
            if (msg.fields[0].tag === 1) {
                matchResult = 2;
                ex = msg.fields[0].fields[0];
            }
            else {
                matchResult = 1;
                filialen = msg.fields[0].fields[0];
            }
            break;
        }
        case 2: {
            matchResult = 3;
            filialeId_1 = msg.fields[0];
            break;
        }
        case 3: {
            if (msg.fields[0].tag === 1) {
                matchResult = 5;
                ex_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 4;
                sendungen = msg.fields[0].fields[0];
            }
            break;
        }
        case 4: {
            matchResult = 6;
            filialeId_3 = msg.fields[0];
            break;
        }
        case 5: {
            matchResult = 7;
            sendung = msg.fields[0];
            break;
        }
        case 8: {
            matchResult = 9;
            files = msg.fields[0][1];
            sendungsId = msg.fields[0][0];
            break;
        }
        case 9: {
            if (msg.fields[0].tag === 1) {
                matchResult = 11;
                exn = msg.fields[0].fields[0];
            }
            else {
                matchResult = 10;
                body = msg.fields[0].fields[0];
            }
            break;
        }
        case 10: {
            matchResult = 12;
            file_1 = msg.fields[0];
            break;
        }
        case 11: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                exn_2 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 13;
                id = msg.fields[0].fields[0];
            }
            break;
        }
        case 7: {
            matchResult = 15;
            sendungsOption = msg.fields[0];
            break;
        }
        case 14: {
            matchResult = 16;
            sendung_1 = msg.fields[0];
            break;
        }
        case 12: {
            matchResult = 17;
            sendung_2 = msg.fields[0];
            break;
        }
        case 17: {
            if (msg.fields[0].tag === 1) {
                matchResult = 21;
                exn_4 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 20;
                s = msg.fields[0].fields[0];
            }
            break;
        }
        case 18: {
            matchResult = 22;
            content = msg.fields[1];
            title = msg.fields[0];
            break;
        }
        case 20: {
            if (msg.fields[0].tag === 1) {
                matchResult = 25;
                exn_6 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 24;
            }
            break;
        }
        case 21: {
            matchResult = 26;
            sendung_3 = msg.fields[0];
            break;
        }
        case 22: {
            if (msg.fields[0].tag === 1) {
                matchResult = 28;
                exn_8 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 27;
                r = msg.fields[0].fields[0];
            }
            break;
        }
        case 24: {
            matchResult = 30;
            tag = msg.fields[0];
            break;
        }
        case 27: {
            matchResult = 33;
            agb = msg.fields[0];
            break;
        }
        case 29: {
            if (msg.fields[0].tag === 1) {
                matchResult = 36;
                exn_10 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 35;
                r_1 = msg.fields[0].fields[0];
            }
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return [new Model(new Remote$1(1, []), model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), request(Http_getFilialen, undefined, (Item) => (new Msg(1, [Item])))];
        case 1: {
            const zentrale = tryFind((f) => f.IsZentrale, filialen);
            const filialeId = (zentrale != null) ? zentrale.FilialeId : (((testExpr = filialen, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 1))) ? item(0, filialen).FilialeId : (((testExpr_1 = filialen, !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 0))) ? undefined : item(0, filialen).FilialeId));
            return [new Model(new Remote$1(3, [filialen]), model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), (model.SelectedFilialeId != null) ? Cmd_none() : defaultArg(map_1((f_3) => singleton((dispatch) => {
                dispatch(new Msg(2, [f_3]));
            }), filialeId), Cmd_none())];
        }
        case 2:
            return [new Model(new Remote$1(2, ["Filialen konnten nicht geladen werden."]), model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 3:
            return [new Model(model.Filialen, filialeId_1, model.ShowInfoBox, new Remote$1(1, []), model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), request(Http_getSendungen, filialeId_1, (Item_1) => (new Msg(3, [Item_1])))];
        case 4:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, new Remote$1(3, [sendungen]), model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 5:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, new Remote$1(2, ["Sendungen konnten nicht geladen werden."]), model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 6:
            return [model, singleton((dispatch_1) => {
                dispatch_1(new Msg(2, [filialeId_3]));
            })];
        case 7:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, sendung, new Sendungen_SendungsOption(0, []), model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 8:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, undefined, undefined, 0, model.Sending, empty(), model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 9: {
            const biggestFile = maxBy((f_4) => f_4.size, files, {
                Compare: comparePrimitives,
            });
            if (biggestFile.size > ((50 * 1024) * 1024)) {
                return [model, (msg_3 = (new Msg(31, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Sendungs-Dateien dürfen maximal 50 MB groß sein.")])])), singleton((dispatch_2) => {
                    dispatch_2(msg_3);
                }))];
            }
            else {
                const cmd_4 = Cmd_batch(map((f_5) => request((tupledArg) => Http_postSendungDateiUpload(tupledArg[0], tupledArg[1]), [sendungsId, f_5], (Item_2) => (new Msg(9, [Item_2]))), files));
                return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount + length(files), model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), cmd_4];
            }
        }
        case 10:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount - 1, model.Sending, append(model.CurrentUploadList, singleton(body)), model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 11:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount - 1, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), errorCmd((Item_3) => (new Msg(31, [Item_3])), "Upload", exn)];
        case 12:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, true, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), request((tupledArg_1) => Http_deleteSendungDateiUpload(tupledArg_1[0], tupledArg_1[1]), [value_2(model.SelectedSendung).SendungId, file_1.Id], (Item_4) => (new Msg(11, [Item_4])))];
        case 13:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, false, filter((x_3) => !(x_3.Id === id), model.CurrentUploadList), model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 14:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, false, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), errorCmd((Item_5) => (new Msg(31, [Item_5])), "Löschen", exn_2)];
        case 15:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, sendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 16:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, sendung_1, new Sendungen_SendungsOption(3, []), model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), State_createInfoBoxCommand(sendung_1, "Diese Sendung kann vollständig ohne Originalbelege oder Kopien abgerechnet werden.", new Msg(15, []))];
        case 17: {
            const message_5 = "Alle Dokumente zu dieser Sendung befinden sich bereits im BFS-Dokumenten-Depot und die Sendung kann ohne weitere Originalbelege bearbeitet werden.";
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, sendung_2, new Sendungen_SendungsOption(2, []), model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), State_createInfoBoxCommand(sendung_2, message_5, new Msg(13, []))];
        }
        case 18:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, undefined, undefined, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_none()];
        case 19:
            return [model, request(Http_getVereinbarung, State_getSendungsOptionData(model), (Item_6) => (new Msg(17, [Item_6])))];
        case 20:
            return [model, State_createPrintLegalCmd("Druckauftrag", s, "Kostenpflichtig übertragen", new Msg(19, []))];
        case 21:
            return [model, errorCmd((Item_7) => (new Msg(31, [Item_7])), "Erstellen der Einverständniserklärung", exn_4)];
        case 22: {
            webPrint(title, content);
            return [model, Cmd_none()];
        }
        case 23:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, true, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), request(Http_postAuftragErteilen, State_getSendungsOptionData(model), (Item_8) => (new Msg(20, [Item_8])))];
        case 24:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, undefined, undefined, 0, false, empty(), model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), Cmd_batch(ofArray([(msg_4 = (new Msg(31, [new GlobalMsg(3, [GlobalMessageBox_SuccessWithTitle("Auftrag erfolgreich erteilt", `Der Auftrag für ${(matchValue_1 = (length(model.CurrentUploadList) | 0), (matchValue_1 === 0) ? "die Sendung" : ((matchValue_1 === 1) ? "eine Datei" : (`${matchValue_1} Dateien`)))} wurde erfolgreich erteilt.`)])])), singleton((dispatch_3) => {
                dispatch_3(msg_4);
            })), (msg_6 = (new Msg(2, [value_2(model.SelectedFilialeId)])), singleton((dispatch_4) => {
                dispatch_4(msg_6);
            }))]))];
        case 25:
            return [model, errorCmd((Item_11) => (new Msg(31, [Item_11])), "Erteilen des Auftrags", exn_6)];
        case 26:
            return [model, request(Http_getFlexitarif, sendung_3.SendungId, (Item_12) => (new Msg(22, [Item_12])))];
        case 27: {
            const matchValue_2 = r.AuszahlungstageMitEntgelt;
            if (!equalsWith(equals, matchValue_2, defaultOf()) && (matchValue_2.length === 0)) {
                return [model, (msg_8 = (new Msg(31, [new GlobalMsg(3, [GlobalMessageBox_ErrorWithTitle("Kein Flexitarif möglich", "Da keine Auszahlungstage zur Auswahl stehen, ist die Wahl des Flexitarifs nicht möglich.")])])), singleton((dispatch_5) => {
                    dispatch_5(msg_8);
                }))];
            }
            else {
                return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, r, new Sendungen_FlexitarifAuswahl(last(r.AuszahlungstageMitEntgelt).Auszahlungstag), model.AgbAkzeptiert), r.BelegeingangErfasst ? ((msg_10 = (new Msg(31, [new GlobalMsg(3, [(message_12 = "Belegeingang bereits erfasst! Wir können eine Vorziehung der Auszahlung nicht zusichern. Bitte beachten Sie in diesem Fall den Hinweis in der Zusatzvereinbarung.", GlobalMessageBox_WarningWithTitle("Belegeingang bereits erfasst", message_12))])])), singleton((dispatch_6) => {
                    dispatch_6(msg_10);
                }))) : Cmd_none()];
            }
        }
        case 28:
            return [model, errorCmd((Item_17) => (new Msg(31, [Item_17])), "Erstellen des Flexitarifs", exn_8)];
        case 29:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, undefined, undefined, false), Cmd_none()];
        case 30:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, (bind$0040 = value_2(model.FlexitarifAuswahl), new Sendungen_FlexitarifAuswahl(tag)), model.AgbAkzeptiert), Cmd_none()];
        case 31:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, !model.AgbAkzeptiert), Cmd_none()];
        case 32:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, true), Cmd_none()];
        case 33:
            return [model, State_createPrintLegalCmd("Zusatzvereinbarung", agb, "Zusatzvereinbarung akzeptieren", new Msg(26, []))];
        case 34: {
            const matchValue_3 = model.Flexitarif;
            const matchValue_4 = model.FlexitarifAuswahl;
            let matchResult_1, a, t;
            if (matchValue_3 != null) {
                if (matchValue_4 != null) {
                    matchResult_1 = 0;
                    a = matchValue_4;
                    t = matchValue_3;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [model, request((tupledArg_2) => Http_postFlexitarif(tupledArg_2[0], tupledArg_2[1]), [t.SendungId, a], (Item_18) => (new Msg(29, [Item_18])))];
                default:
                    throw new Error("bad model state");
            }
        }
        case 35:
            return [new Model(model.Filialen, model.SelectedFilialeId, model.ShowInfoBox, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, undefined, undefined, false), Cmd_batch(ofArray([(msg_12 = (new Msg(31, [new GlobalMsg(3, [GlobalMessageBox_SuccessWithTitle("Flexitarif erfolgreich gewählt", `Der Flexitarif für Sendung ${r_1.SendungsNr} wurde erfolgreich gewählt. Das Entgelt beläuft sich auf ${asMoney(r_1.Entgelt)}.`)])])), singleton((dispatch_7) => {
                dispatch_7(msg_12);
            })), (msg_14 = (new Msg(2, [value_2(model.SelectedFilialeId)])), singleton((dispatch_8) => {
                dispatch_8(msg_14);
            }))]))];
        case 36:
            return [model, errorCmd((Item_21) => (new Msg(31, [Item_21])), "Wählen des Flexitarifs", exn_10)];
        case 37:
            return [new Model(model.Filialen, model.SelectedFilialeId, false, model.Sendungen, model.SelectedSendung, model.SelectedSendungsOption, model.CurrentUploadCount, model.Sending, model.CurrentUploadList, model.Flexitarif, model.FlexitarifAuswahl, model.AgbAkzeptiert), singleton((dispatch_9) => {
                dispatch_9(new Msg(31, [new GlobalMsg(7, [State_SESSION_DATA_KEY_INFO_BOX_HIDDEN, ""])]));
            })];
        default:
            throw new Error("Not Implemented");
    }
}

//# sourceMappingURL=State.fs.js.map
